import React, { useState } from 'react';
import { Col, Row } from 'reactstrap';
import { Button, ButtonGroup } from 'edozvola-frontend-lib/dist/ui';
import ViewTableHeaderColumn from 'app/shared/view-table/view-table-header-column';
import ViewTable from 'app/shared/view-table/view-table';
import { CasesFilter, initialCasesFilter, PubWebCaseView } from 'app/edozvola/cases/cases.model';
import { convertDateFromServer } from 'app/shared/util/date-utils';
import { createCaseAmendmentMutation, searchParticipantCasesQuery } from 'app/modules/pub-web-cases/service/pub-web-cases.queries';
import { fetchCaseInPreview, initialCaseState, setCase } from 'app/shared/reducers/case-entity';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { useNavigate } from 'react-router-dom';
import { MANDATES } from 'app/config/constants';
import {getPaginationSearchParam, paginationKeys} from "app/shared/util/pagination.constants";
import CasesFilterModal from 'app/edozvola/cases/case-filter/cases-filter-modal';
import { getPaginationFilter } from 'app/shared/pagination/pagination.util';
import { declassify } from 'edozvola-frontend-lib/dist/util';
import _ from 'lodash';
import { TooltipWrapper } from 'edozvola-frontend-lib/dist/ui/components/tooltipwrapper';

const MyCases = () => {
 const [casesFilterModalShown, setCasesFilterModalShown] = useState(false);
  const [casesFilter, setCasesFilter] = useState<CasesFilter>(getPaginationFilter(paginationKeys.PARTICIPANT_CASES) ?? initialCasesFilter);

  const appDispatch = useAppDispatch();
  const navigate = useNavigate();
  const szSubjectOfRepresentationSelected = useAppSelector(state => state.authentication.account.szSubjectOfRepresentationSelected);
  const mandate = useAppSelector<string[] | undefined>(state => state.authentication.account.mandate);
  const isCaseDetailBlocked = szSubjectOfRepresentationSelected === true && !(mandate ?? []).includes(MANDATES.VIEW);
  const canAddAmendment = szSubjectOfRepresentationSelected !== true || (mandate ?? []).includes(MANDATES.ADDITION);

  const getFilterValue = (filterKey: string) => {
    if (localStorage.getItem(`${filterKey}-filter`) && localStorage.getItem(`${filterKey}-filter`) !== null) {
      return localStorage.getItem(`${filterKey}-filter`) === 'true';
    } else {
      return null;
    }
  };

  const [edozvolaFilter, setEdozvolaFilter] = useState(getFilterValue(`${paginationKeys.PARTICIPANT_CASES} - eDozvola`) ?? true);
  const [earhivaFilter, setEarhivaFilter] = useState(getFilterValue(`${paginationKeys.PARTICIPANT_CASES} - eArhiva`) ?? false);

  const { mutate: startCaseAmendment, isPending } = createCaseAmendmentMutation('participat-cases');

  const openCaseInPreview = (caseUuid: string) => {
    appDispatch(fetchCaseInPreview(caseUuid)).then(() => navigate('/cases-preview/' + caseUuid, { state: { from: 'participat-cases' } }));
  };

  const startCaseAmendmentAndDisablePropagation = (event: any, idCase: number) => {
    appDispatch(setCase(initialCaseState))
    event.stopPropagation()
    startCaseAmendment(idCase)
  }

  const setFilterValue = (filterKey: string, value) => {
    return localStorage.setItem(`${filterKey}-filter`, value);
  };

  const filterActive = () => {
    return !_.isEqual(casesFilter, initialCasesFilter);
  };

  const resetCasesFilter = () => {
    setCasesFilter(initialCasesFilter);
    localStorage.removeItem(`${paginationKeys.PARTICIPANT_CASES}-filter-form`);
  };

  const renderParticipantCasesTableRow = (value: PubWebCaseView, caseActIndex: number) => {
    return (
      <tr
        key={caseActIndex}
        className={isCaseDetailBlocked ? undefined : 'hand'}
        onClick={isCaseDetailBlocked ? undefined : () => openCaseInPreview(value.uuid)}
      >
        <td>{value.classification}</td>
        <td>{convertDateFromServer(value.createdDate)}</td>
        <td>{value.caseCategory}</td>
        <td className="break-words-column">{value.description}</td>
        <td>{value.caseStatus}</td>
        <td>{value.lastCaseActName}</td>
        <td>{convertDateFromServer(value.lastCaseCreatedDate)}</td>
        <td>
          <div className={'d-flex gap-3'}>
            {value.createAmendmentVisible && canAddAmendment && (
              <Button
                className={'button-in-action-column'}
                label={'Predaj pismeno'}
                color={'info'}
                onClick={event => startCaseAmendmentAndDisablePropagation(event, value.idCase)}
              />
            )}
          </div>
        </td>
      </tr>
    );
  };


  return (
    <>
      <div className={'container-fluid view-container'}>
        <Row className="mb-4">
          <Col md={12}>
            <div className={'mb-3 form-header'}>Predmeti u kojima sudjelujem</div>
          </Col>
        </Row>
        <div className={'d-flex gap-2 mb-3'}>
          <ButtonGroup>
            <Button
              label={'eDozvola'}
              size={'lg'}
              color={'primary'}
              className={declassify({ active: edozvolaFilter })}
              onClick={e => {
                setFilterValue(`${paginationKeys.PARTICIPANT_CASES} - eDozvola`, earhivaFilter ? !edozvolaFilter : true);
                setEdozvolaFilter(earhivaFilter ? !edozvolaFilter : true);
                e.currentTarget.blur();
              }}
            />
            <Button
              label={'eArhiva'}
              size={'lg'}
              color={'primary'}
              className={declassify({ active: earhivaFilter })}
              onClick={e => {
                setFilterValue(`${paginationKeys.PARTICIPANT_CASES} - eArhiva`, edozvolaFilter ? !earhivaFilter : true);
                setEarhivaFilter(edozvolaFilter ? !earhivaFilter : true);
                e.currentTarget.blur();
              }}
            />
          </ButtonGroup>
          <div>
            {!filterActive() && (
              <ButtonGroup className={'ms-3'}>
                <Button
                  className={'btn-full-width'}
                  prependIcon={'filter'}
                  size={'lg'}
                  color={'primary'}
                  label="Dodatni filteri"
                  onClick={e => {
                    setCasesFilterModalShown(true);
                    e.currentTarget.blur();
                  }}
                ></Button>
              </ButtonGroup>
            )}
            {filterActive() && (
              <div className={'custom-btn-group ms-3'}>
                <Button
                  className={'btn-group-first-button btn-primary-width'}
                  prependIcon={'filter'}
                  color={'info'}
                  size={'lg'}
                  label="Dodatni filteri"
                  onClick={e => {
                    setCasesFilterModalShown(true);
                    e.currentTarget.blur();
                  }}
                ></Button>
                <TooltipWrapper message={'Poništi dodatne filtere'}>
                  <Button
                    className={'btn-group-last-button btn-secondary-width'}
                    prependIcon={'xmark'}
                    color={'info'}
                    size={'lg'}
                    label=" "
                    onClick={e => {
                      resetCasesFilter();
                      e.currentTarget.blur();
                    }}
                  ></Button>
                </TooltipWrapper>
              </div>
            )}
          </div>
        </div>
        <ViewTable
          initialPaginationColumn="createdDate"
          initialSortDirection="desc"
          renderTableRow={renderParticipantCasesTableRow}
          noDataMessage={filterActive() ? ' Nema predmeta koji odgovaraju unesenim parametrima.' : 'Nema predmeta u kojima sudjelujete.'}
          fetchDataQuery={searchParticipantCasesQuery}
          fetchDataProps={{ ...casesFilter, earhivaFilter: earhivaFilter, edozvolaFilter: edozvolaFilter }}
          localStorageKey={paginationKeys.PARTICIPANT_CASES}
        >
          <ViewTableHeaderColumn renderSort sortKey={'classification'} columnLabels={['Klasifikacijska oznaka']} />
          <ViewTableHeaderColumn renderSort sortKey={'createdDate'} columnLabels={['Datum kreiranja predmeta']} />
          <ViewTableHeaderColumn renderSort sortKey={'caseCategory'} columnLabels={['Vrsta predmeta']} />
          <ViewTableHeaderColumn renderSort sortKey={'description'} columnLabels={['Kratki opis']} />
          <ViewTableHeaderColumn renderSort sortKey={'caseStatus'} columnLabels={['Status predmeta']} />
          <ViewTableHeaderColumn renderSort sortKey={'lastCaseActName'} columnLabels={['Zadnji akt']} />
          <ViewTableHeaderColumn renderSort sortKey={'lastCaseCreatedDate'} columnLabels={['Datum nastanka akta']} />
          <ViewTableHeaderColumn renderSort={false} columnLabels={['Akcije']} width={'140px'} />
        </ViewTable>
      </div>
      {casesFilterModalShown && (
        <CasesFilterModal
          filterForm={casesFilter}
          setFilterForm={setCasesFilter}
          modal={casesFilterModalShown}
          closeModal={() => setCasesFilterModalShown(false)}
          paginationKey={paginationKeys.PARTICIPANT_CASES}
        />
      )}
    </>
  );

}

export default MyCases;
